const Theme = {
  primary5: '#484F87',
  primary4: '#4E59AD',
  primary1: '#5F6FEE',
  primary2: '#A6AEED',
  primary3: '#CACEED',
  primary1Transparent: 'rgba(95,111,238,0.5)',
  primaryTransparent: 'rgba(202,206,237,0.5)',
  black: '#000',
  grey4: '#666B8C',
  grey3: '#9296B3',
  grey2: '#D8D9E6',
  grey1: '#F2F2F5',
  white: '#FFF',
  green1: '#56D68B',
  yellow1: '#FFC15E',
  red1: '#EF6F6C',
  fontWeights: {
    regular: 400,
    semibold: 600
  }
}
export default Theme
